import "./styles.less";

import React from "react";
import { useActiveFiltersTags } from "./ActiveFiltersTags.hook";
import { useSearchResultsFilters } from "../Filters/SearchResultsFilters.hook";

const ActiveFiltersTags = () => {
	const { filtersTagsToShow } = useActiveFiltersTags();
	const { changeFiltersAndUpdateURL } = useSearchResultsFilters();

	return (
		<div className="filter-tag-wrap">
			{filtersTagsToShow.map((o, i) => {
				return (
					<span className="filter-tag" key={o.key + "_" + i}>
						{o.text}
						{o.deleteable &&
							<span className="close" onClick={() => { changeFiltersAndUpdateURL(o.onChangeObject) }}>x</span>
						}
					</span>

				);

			})}
		</div>
	);
};

export { ActiveFiltersTags };
